module.exports = __webpack_public_path__ + "static/media/pdficon.96221021.png";